import axios from "../utils/axios";

export const getProjectSettings = async () => {
    const response = await axios.get("/settings/project-page");
    return response.data;
};

export const updateProjectSettings = async (data) => {
    const response = await axios.put("/settings/project-page", data);
    return response.data;
};
